// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../../utils';
import { PM_2DISPLAY_MAPPING } from '../../../consts/consts';

export const InvoicePagePaidDateAndMethod = ({
  paymentDate,
  paymentMethod,
}: {
  paymentDate: string;
  paymentMethod: string;
}) => {
  const { t } = useTranslation();
  return (
    <div className='bg-bw00 h-[78px] border-bw03 py-[12px] px-[24px] border-b-[1px]'>
      <div className='flex justify-between'>
        <div className='text-md font-metricR text-bw07 leading-6'>Payment date</div>
        <div className='text-md font-metricR text-bw07 leading-6'>{formatDate(paymentDate, true, true)}</div>
      </div>
      <div className='flex justify-between mt-[5px]'>
        <div className='text-md font-metricR text-bw07 leading-6'>Payment method</div>
        <div className='text-md font-metricR text-bw07 leading-6'>{t(PM_2DISPLAY_MAPPING?.[paymentMethod])}</div>
      </div>
    </div>
  );
};
